import { createFileRoute } from '@tanstack/react-router';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { AbsenceAdminPanel } from '../../features/people/components/absence-admin-panel';

export const Route = createFileRoute('/_app/absences')({
  component: AbsencesPage,
});

/**
 * Nghỉ phép — APM-ORG-f3.
 *
 * ## Vì sao là trang riêng, không phải một mục trong `/admin`
 *
 * `/admin` hiện với người có `user:manage`, tức chỉ `ORG_ADMIN` và
 * `SUPER_ADMIN`. Nhưng nghỉ phép là việc **mọi người** đều làm: nhân viên xin
 * nghỉ, trưởng nhóm duyệt cho nhóm mình. Chôn nó sau một trang quản trị là
 * khoá nó với đúng những người dùng nó nhiều nhất.
 *
 * Không gắn quyền ở route: phạm vi do API quyết theo vai trò người gọi
 * (`absence.controller.ts`) — nhân viên thấy đơn của mình, trưởng nhóm thấy
 * thêm nhóm mình, giám đốc và quản trị thấy cả tổ chức.
 */
function AbsencesPage(): ReactNode {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <header className="flex flex-col gap-1" data-tour="absences-page">
        <h1 className="text-xl font-medium">{t('absence.adminTitle')}</h1>
        <p className="text-sm text-muted-foreground">{t('absence.pageSubtitle')}</p>
      </header>

      <AbsenceAdminPanel />
    </div>
  );
}
